import { useField } from 'formik';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useQuerySSOs } from 'gql/queries/sso';

import SSO from './SSO';

const SSOContainer = (props) => {
  const { t } = useTranslation();
  const [{ value: organization }] = useField('organization');
  const [institution, setInstitution] = useState('');
  const [selectedSSO, setSelectedSSO] = useState();
  const { isLoading, data } = useQuerySSOs();
  const ssos = isLoading ? [] : data.SSOs;
  const displayedSSOs =
    organization?.SSOs.length > 0 ? organization?.SSOs : ssos;
  const handleSSOSelect = useCallback((sso) => {
    setSelectedSSO(sso);
    setInstitution(sso.name);
  }, []);
  const handleInputFocus = useCallback(() => {
    setInstitution('');
  }, []);
  const handleInputChange = useCallback((event) => {
    setInstitution(event.target.value);
  }, []);
  const handleInputBlur = useCallback(
    (event) => {
      if (event.relatedTarget?.className !== 'MenuItem_container__jModb') {
        setInstitution(selectedSSO?.name || '');
      }
    },
    [selectedSSO],
  );
  return (
    <SSO
      handleInputBlur={handleInputBlur}
      handleInputChange={handleInputChange}
      handleInputFocus={handleInputFocus}
      handleSSOSelect={handleSSOSelect}
      institution={institution}
      organization={organization}
      selectedSSO={selectedSSO}
      ssos={displayedSSOs}
      t={t}
      {...props}
    />
  );
};

export default SSOContainer;
